import { Component, Output, EventEmitter, Input } from '@angular/core';

import { HisNavigationService, HisNotificationService, HisUiService, HisAuthService, HisGlobalDataService } from 'hisng';

import { JournalService } from 'app/fs/res/publication/service/journal.service';
import { Journal } from 'app/fs/res/publication/model/journal';
import {DATA_SERVICE_KEY_PUBLICATION,DATA_SERVICE_KEY_REASEARCH_ACTIVITY,
    DATA_SERVICE_KEY_CHILD_PUBLICATION, 
    NO_PEER_REVIEW_HISKEY_ID} from 'app/fs/res/publication/model/constants';
import { ResearchActivity } from '../../../research-activity/model/research-activity';
import { Publication } from '../../../publication/model/publication';
import { JournalModuleOptions } from 'app/fs/res/publication/component/journal/journal-module.options';


@Component({
    selector: 'res-journal-plam',
    templateUrl: './journal-plam.component.html',
})
export class JournalPlamComponent {
    public readonly moduleOptions = JournalModuleOptions;

    @Input('selectedJournal') set journal(j: Journal) {
        this.selectedJournal = {journal: j, fullTitle: this.getJournalFullTitle(j)};
        this.isWithoutPeerReviewProcess = this.selectedJournal.journal?.peerReviewed?.hiskeyId === NO_PEER_REVIEW_HISKEY_ID;
    }
    @Input() researchActivity: ResearchActivity;
    @Input() childPublication: Publication;
    @Input() publication: Publication;
    @Input() dDKey = '';
    @Output() selectedJournalChange = new EventEmitter<Journal>();
    @Output() navigationLastUrlChange = new EventEmitter<string>();

    selectedJournal: { journal: Journal; fullTitle: string };
    public filteredJournals: { journal: Journal; fullTitle: string }[];
    public dateFormat: string;
    isWithoutPeerReviewProcess: boolean;

    constructor(public auth: HisAuthService,
        private journalService: JournalService,
        private navigationService: HisNavigationService,
        private notificationService: HisNotificationService,
        public hisUiService: HisUiService,
        private globalDataService: HisGlobalDataService) {
        this.dateFormat = this.hisUiService.translate('common.dateFormat');
    }

    getJournalFullTitle(journal: Journal) {
        if (journal?.defaulttext) {
            return journal?.subtitle ? journal.defaulttext + ' : ' + journal.subtitle : journal.defaulttext;
        } else {
            return '';
        }
    }

    // autocomplete functions #########################################################################################################
    public filterJournal(event: { query: string }) {
        let query = event.query;
        this.journalService.getJournals(query).subscribe( (j: Journal[]) => {
            this.filteredJournals = j.map(journal => ({ journal, fullTitle: this.getJournalFullTitle(journal) }));
        });
    }

    // manipulation methods ################################################################################################

    /* clear autoComplete input field */
    public onClear(): void {
        this.selectedJournal = null;
        this.selectedJournalChange.emit(null);
    }

    public onSelectByAutocomplete() {
        if (!this.selectedJournal) {
            this.notificationService.errorI18nRes('fs.res.publication.journal.error');
        } else {
            this.selectedJournalChange.emit(this.selectedJournal.journal);
        }
    }

    public onSelectBySearchPopup($event: any[]) {
        // convert search result into Journal object
        let journalId: number = parseInt($event[0].id, 10);
        this.journalService.getJournalById(journalId).subscribe( (j: Journal) => {
            this.selectedJournal = { journal: j, fullTitle: this.getJournalFullTitle(j) };
            this.selectedJournalChange.emit(this.selectedJournal.journal);
        });
    }

    // getter ##############################################################################################################

    public getJournals(): Journal[] {
        return this.selectedJournal?.journal ? [this.selectedJournal.journal] : [];
    }

    /* leaving page action use onBeforeNavigate set current objects to globalDataService */
    public onBeforeNavigate() {
        this.navigationLastUrlChange.emit( window.location.href );

        if(this.researchActivity){
            this.globalDataService.setData( DATA_SERVICE_KEY_REASEARCH_ACTIVITY, this.researchActivity );
            this.navigationService.stopDirtyTracking();
        } else {
            this.globalDataService.setData(DATA_SERVICE_KEY_PUBLICATION, this.publication);
            if (this.childPublication) {
                this.globalDataService.setData(DATA_SERVICE_KEY_CHILD_PUBLICATION, this.childPublication);
            }
            this.navigationService.stopDirtyTracking();
        }
    }
}
